export const SOFTLINE_API_ESL_ASSOCIATE = '/v1/esl/associate';
export const SOFTLINE_API_ESL_DISSOCIATE = '/v1/esl/dissociate';

export const SOFTLINE_API_ESL_STORAGE_CONFIG = '/esl-service/esl/config/{{eslCode}}';
export const SOFTLINE_API_ESL_STORAGE_ASSOCIATE = '/esl-service/esl/associate';
export const SOFTLINE_API_ESL_STORAGE_CHECK_LOCATION =
  '/esl-service/esl/{{eslCode}}/checkStorageLocation';
export const SOFTLINE_API_ESL_STORAGE_CHANGE_LOCATION =
  '/esl-service/esl/changeStorageLocation';
export const SOFTLINE_API_ESL_STORAGE_PREVIEW = '/esl-service/esl/preview';
export const SOFTLINE_API_ESL_STORAGE_DISSOCIATE =
  '/esl-service/esl/{{eslCode}}/dissociate';

export const SOFTLINE_API_ESL_STORAGE_LOCATION_SCAN =
  '/esl-service/esl/storage-location/scan/{{storageLocationCode}}';

export const SOFTLINE_API_ESL_STORAGE_LOCATIONS = '/v1/bean/query/lagerplatz';
